<template>
	<div id="app">
		<div class="container-game">
			<router-view></router-view>
			<alert-global v-if="showAlert"
				:imageSrc="objectAlert.imageSrc"
				:title="objectAlert.title"
				:subtitle="objectAlert.subtitle"
				:route="objectAlert.route"></alert-global>
		</div>
	</div>
</template>
<script>
import AlertGlobal from './components/Alerts/AlertGlobal'
import middleware from './middleware/middleware.js'
import Bus from '@/main.js'
import i18n from "@/plugins/i18n";
export default {
	components: {
		AlertGlobal
	},
	data(){
		return {
			objectAlert : {},
			showAlert : false
		}
	},
	async created(){
		// document.documentElement.requestFullscreen();
		Bus.$on('openAlertGlobal', this.openAlertGlobal)
		Bus.$on('closeAlertGlobal', this.closeAlertGlobal)
		const language = localStorage.getItem("language")
		i18n.locale = language ? language : "pt-br"
		let routeName = this.$route.path
		if(routeName == '/redirectAuth' || routeName == '/redirectExternal' || routeName == '/'){
			return 
		}  
		const { token, userId } = this.$store.getters.getSimple(["token", "userId"])
		if(!token){
			middleware.redirectAuth()
			return 
		}
		let authenticated = await middleware.verifyAuth(token)
		if(!authenticated){
			middleware.redirectAuth()
			return
		}
		let statusSchedule = await middleware.verifySchedule(userId)
		this.$router.push({ name : statusSchedule.name, params : { status : statusSchedule.status }})
	},
	destroyed(){
		Bus.$off('openAlertGlobal')
		Bus.$off('closeAlertGlobal')
	},
	methods: {
		openAlertGlobal(objectAlert){
			// console.log("objectAlert: ", objectAlert)
			this.objectAlert = objectAlert
			this.showAlert = true
		},
		closeAlertGlobal(){
			this.showAlert = false
		}
	}
}
</script>
<style lang="scss">
	@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@100;400;700;900&display=swap');
	@import url('./assets/css/animate.css');
	*{
		margin: 0;
		padding: 0;
		font-family: Raleway;
		box-sizing: border-box;
	}

	html{
		overflow-x: visible;
	}

	#app{

		width: 100%;
		max-width: 100%;
		background-color: rgb(182, 182, 182);
		display: flex;
		flex-direction: column;
		justify-content: center;

		.container-game{

			width: 100%;
			margin: 0 auto;
			background-color: white;
			position: relative;
		}
	}

	.bold{

		font-weight: bold;
	}
	
	
		@media only screen and (min-width : 600px) {
				
			#app{
				min-height: 100vh;
				max-height: 100vh;

				.container-game{

					max-width: 920px;
					height: 650px;
				}
			}
		}
</style>
